import { Link } from 'react-router-dom';
import { CATEGORIES } from '@/types/movie';

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-20 border-t border-background-300/40 bg-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-white">
                <i className="ri-moon-fill text-lg"></i>
              </span>
              <span className="font-display text-xl tracking-wide text-foreground-950">午夜小电影</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              专注精选各类午夜主题短片与电影，涵盖剧情、悬疑、恐怖等类型。我们希望成为你在深夜找片时，
              那个懂你胃口的小小片单。
            </p>
            <div className="mt-5 flex gap-3">
              {[
                { icon: 'ri-mail-line', label: '邮箱' },
                { icon: 'ri-weibo-line', label: '微博' },
                { icon: 'ri-bilibili-line', label: '哔哩哔哩' },
              ].map((s) => (
                <span
                  key={s.label}
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-background-200/70 text-foreground-600"
                  title={s.label}
                >
                  <i className={s.icon}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-950">影片分类</h4>
            <ul className="mt-4 flex flex-col gap-3">
              {CATEGORIES.map((cat) => (
                <li key={cat.key}>
                  <Link
                    to={`/category/${encodeURIComponent(cat.key)}`}
                    className="text-sm text-foreground-600 transition hover:text-primary-400"
                  >
                    {cat.label}类午夜影片
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-950">网站导航</h4>
            <ul className="mt-4 flex flex-col gap-3">
              <li>
                <Link to="/" className="text-sm text-foreground-600 transition hover:text-primary-400">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-sm text-foreground-600 transition hover:text-primary-400">
                  搜索影片
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 transition hover:text-primary-400">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about#privacy" className="text-sm text-foreground-600 transition hover:text-primary-400">
                  隐私政策
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-300/40 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 午夜小电影 · Midnight Cinema. 保留所有权利。</p>
          <p>本站内容仅为影片资讯与推荐演示，不提供在线播放与下载。</p>
        </div>
      </div>
    </footer>
  );
}